<template>
  <div>


<el-container>
      <!-- 顶部 -->
  <el-header> 
    <div>
      <div class="bamtopclass">学生个人管理</div>
      <div class="removeLogin"><el-button type="primary" @click="outlogin"> 退出登录</el-button></div>
      <div><span class="username">{{username}}</span></div>
    </div>
  </el-header>
  <el-container class="home_class">
    <el-aside width="200px">
          <!-- 左侧 -->
    <el-menu router class="el-menu-vertical-demo">

      <!-- 一级菜单 -->
      <el-submenu index="1">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-huibao"></span>
          <span>学习汇报</span>
        </template>
          <!-- 二级菜单 -->
        <el-menu-item-group>
          <el-menu-item index="Report">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span >汇报列表</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
                  <!-- 二级菜单 -->
        <el-menu-item-group>
          <el-menu-item index="ieltsDeclare">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span >雅思申报</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>

            <el-menu-item-group>
          <el-menu-item index="ViewIelts">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span >雅思申报列表</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

         <!-- 一级菜单 -->
      <el-submenu index="2">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-gerenxinxi1"></span>
          <span>个人信息</span>
        </template>
          <!-- 二级菜单 -->
              <el-menu-item-group>
          <el-menu-item index="EVPI">
             <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-yonghuguanli"></span>
          <span>个人信息完善</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
      </el-submenu>



         <el-submenu index="3">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-chaxun"></span>
          <span>学习成绩查询</span>
        </template>
          <!-- 二级菜单 -->
         <el-menu-item-group>
          <el-menu-item index="CheckScore">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-chaxun1"></span>
          <span >批改网成绩查询</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <el-menu-item index="IeltsStudentText">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-chaxun1"></span>
          <span >雅思模拟成绩查询</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>
        
         <el-menu-item-group>
          <el-menu-item index="CheckEnglish">
             <template slot="title">
              <!-- 图标 -->
        <span class="iconfont icon-chaxun1"></span>
          <span >学习通成绩查询</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>

      </el-submenu>
      
      <el-submenu index="4">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-chaxun"></span>
          <span>网上预约</span>
        </template>
          <!-- 二级菜单 -->
         <el-menu-item-group>
          <el-menu-item index="Apponintment">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-chaxun1"></span>
          <span >我的预约</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>


      </el-submenu>
      <el-submenu index="14">
        <template slot="title">
         <span class="iconfont icon-chaxun"></span>
          <span>调查问卷</span>
        </template>
         <el-menu-item-group>
          <el-menu-item index="studentAnswerQuestion">
             <template slot="title">
           <span class="iconfont icon-chaxun1"></span>
          <span >查看调查问卷</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>


      </el-submenu>

               <!-- 一级菜单 -->
               <el-submenu index="11" v-if="addType==8">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-gerenxinxi1"></span>
          <span>工作任务</span>
        </template>
          <!-- 二级菜单 -->
              <el-menu-item-group >
          <el-menu-item index="CheckRoom">
             <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-yonghuguanli"></span>
          <span>查寝信息</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
 
    </el-aside>

    <el-container>
      <el-main>

        <router-view></router-view>
        
        </el-main>
      <el-footer>Footer</el-footer>
    </el-container>
  </el-container>
</el-container>
  </div>
</template>


<script>
import "@/components/work/until/icon/iconfont.css"
export default {
  created(){
    this.newscli()
  },
  methods:{
    newscli(){
      this.username=JSON.parse(localStorage.getItem('user')).username 
      this.addType=JSON.parse(localStorage.getItem('user')).addType 
    },
    outlogin(){
      localStorage.removeItem('user');
      localStorage.removeItem('token');
       this.$router.push({  
                    name: 'Login',  
                  })
    }
  },data(){
      return{
        username:'',
        addType:'',
      }}

}
</script>

<style scoped>
 .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
    min-width: 1400px;
  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    line-height: 200px;
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    min-width: 1200px;
  }
  .home_class{
    height: 800px;
  }
  .removeLogin{
   float:right;
  }
 .bamtopclass{
  float: left;
  padding-left: 45%;
 }
 .icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.username{
  padding-left: 38%;
}
</style>


// WEBPACK FOOTER //
// src/components/work/student/StudentBam.vue